import React,{useState,useEffect,useRef} from 'react'
import { Row, Col, Carousel, DatePicker } from 'antd'
import * as echarts from 'echarts';
import Map from './map';
import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import * as Home from '@/common/api/home'
function Main(props) {
    const ticket = useRef({
        ticketDataList: [],
        echartObj: null
    })
    const equipmentRef = useRef({
        equipmentQuery: {
            queryType: 1,
            dateType: 2,
            startDate: undefined,
            endDate: undefined
        }
    })
    const { RangePicker } = DatePicker;
    const [onlineCount,setOnlineCount] = useState()
    const [areaStatisticsList, setAreaStatisticsList] = useState([])
    const [dataQueryType, setDataQueryType] = useState(1)
    const [noCompletedTicketList, setNoCompletedTicketList] = useState([])
    const [pendingAlertList, setPendingAlertList] = useState([])
    const [pendingFaulttList, setPendingFaulttList] = useState([])
    const [dispatchStatisticsList, setDispatchStatisticsList] = useState(
        [
            {
                name: '合作区',
                num: 50
            },
            {
                name: '临海新城',
                num: 24
            },
            {
                name: '滨海旅游区',
                num: 14
            }
        ]
    )
    // 工作量数据处理
    const [ticketList, setTicketList] = useState([])
    const [gzltjTime, setGzltjTime] = useState('近一月')
    const [alertType,setAlertType] = useState(props.isShowAlertType)
    const [initDomStatus, setInitDomStatus] = useState(undefined)
    const [selectAlertOrFault, setSelectAlertOrFault] = useState('0')
    const [selectStatisticsType, setselectStatisticsType] = useState('工单量')
    const [selectStatisticsTime, setselectStatisticsTime] = useState('近一月')
    //获取工作量统计模块的数据
    const getTicketDataList = (data) => {
        const params = {
            dateType: data ? data : 2,
            moduleKey: 'workNum',
            dataQueryType: dataQueryType
        }
        Home.getTypeData(params).then(res => {
            if (res.code === 0 && res.data[0]) {
                const data = []
                res.data[0].data.map(item => {
                    if (item.ticketName === '巡检工单') {
                        data.push({
                            name: item.ticketName,
                            count: Number(item.totalNum),
                            num: item.completedNum ?  item.completedNum : 0,
                            color: 'red'
                        })
                    } else if (item.ticketName === '故障工单') {
                        data.push({
                            name: item.ticketName,
                            count: Number(item.totalNum),
                            num: item.completedNum ?  item.completedNum : 0,
                            color: 'yellow'
                        })
                    } else if (item.ticketName === '告警工单') {
                        data.push({
                            name: item.ticketName,
                            count: Number(item.totalNum),
                            num: item.completedNum ?  item.completedNum : 0,
                            color: 'blue'
                        })
                    }
                })
                ticket.current = {
                    ...ticket.current,
                    ticketDataList: data
                }
                setTicketList(data)
            }
        })
    }
    // 通过工作量数据来进行option配置
    const initTicketEchartOption = () => {
        const dom = document.getElementById('ticket')
        const option = {
            title: {
                text: ''
            },
            legend: {
                data: []
            },
            grid: {
                width: '65%',
                left: '20%',
                top: '0',
                right: '0',
                bottom: '0'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'none'
                },
                formatter: function (params) {
                  if (params[0].name === '巡检工单') {
                    let num = 0
                    let label = 0
                    ticket.current.ticketDataList.some(item => {
                        if (item.name === params[0].name) {
                            num = item.num
                            label = item.num <= 0 ? 0 : (Math.round(item.num / item.count * 100))
                            return true
                        }
                    })
                    return '<span style=\'display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#ff4d4f;\'></span>' +
                      params[0].name + ' : ' + num + ' 个<br/>' + '<span style=\'margin-left:13px\'>所占总数'+label+'%</span>'
                  } else if (params[0].name === '故障工单') {
                    let num = 0
                    let label = 0
                    ticket.current.ticketDataList.some(item => {
                        if (item.name === params[0].name) {
                            num = item.num
                            label = item.num <= 0 ? 0 : (Math.round(item.num / item.count * 100))
                            return true
                        }
                    })
                    return '<span style=\'display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#ff9933;\'></span>' +
                      params[0].name + ' : ' + num + ' 个<br/>' + '<span style=\'margin-left:13px\'>所占总数'+label+'%</span>'
                  } else if (params[0].name === '告警工单') {
                    let num = 0
                    let label = 0
                    ticket.current.ticketDataList.some(item => {
                        if (item.name === params[0].name) {
                            num = item.num
                            label = item.num <= 0 ? 0 : (Math.round(item.num / item.count * 100))
                            return true
                        }
                    })
                    return '<span style=\'display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:green;\'></span>' +
                      params[0].name + ' : ' + num + ' 个<br/>' + '<span style=\'margin-left:13px\'>所占总数'+label+'%</span>'
                  }
                }
            },
            xAxis: {
                show: false,
                type: 'value'
            },
            yAxis: [
                {
                    type: 'category',
                    inverse: true,
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: 'white',
                            fontSize: '16px'
                        }
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    }
                },
                {
                    type: 'category',
                    inverse: true,
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: 'white',
                            fontSize: '20px'
                        },
                        formatter: (value) => {
                            return value
                        }
                    },
                    data: [],
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    }
                }
            ],
            series: [
                {
                    type: 'bar',
                    zlevel: 1,
                    itemStyle: {
                        normal: {
                            barBorderRadius: 30,
                            color: function (params) {
                                if (params.name === '巡检工单') {
                                 return '#ff4d4f'
                                } else if (params.name === '故障工单') {
                                 return '#ff9933'
                                } else if (params.name === '告警工单') {
                                 return 'green'
                                }
                            }
                        }
                    },
                    // label: {
                    //     normal: {
                    //         show: true,
                    //         position: ['300%', '-250%'],
                    //         color: '#fff',
                    //         fontSize: 15,
                    //         formatter: function(param) {
                    //             let label = 0
                    //             if (ticket.current.ticketDataList.length > 0) {
                    //                 ticket.current.ticketDataList.some(item => {
                    //                     if (item.name === param.name) {
                    //                         label = item.num <= 0 ? 0 : (Math.round(item.num / item.count * 100))
                    //                         return true
                    //                     }
                    //                 })
                    //             }
                    //             return label + '%'
                    //         }
                    //     }
                    // },
                    barWidth: 5,
                    data: []
                },
                {
                    name: '背景',
                    type: 'bar',
                    barWidth: 5,
                    barGap: '-100%',
                    data: [100, 100, 100],
                    itemStyle: {
                        normal: {
                            color: '#ccc',
                            barBorderRadius: 30
                        }
                    }
                }
            ]
        }
        option.series[0].data = []
        // option.series[1].data = []
        // option.yAxis[1].data = []
        option.yAxis[0].data = []
        ticketList.forEach(item => {
            option.legend.data.push(item.name)
            if (item.num / item.count * 100 === 100) {
                option.series[0].data.push(100)
            } else {
                const num = parseInt(item.num / item.count * 100)
                option.series[0].data.push(num)
            }
            // option.series[0].data.push(item.num)
            option.yAxis[0].data.push(item.name)
        })
        // const arr = ticketList.reverse()
        const arr = ticketList
        arr.forEach(i => {
            option.yAxis[1].data.push(i.count)
        })
        ticket.current.echartObj = echarts.init(dom)
        ticket.current.echartObj.setOption(option, true)
        ticket.current.echartObj.resize({ height: '130px' })
        initTicketEchartDom()
    }
    // 初始化工作量dom
    const initTicketEchartDom = () => {
        return (
            <div className="ticketEchart" id="ticket" ref={ticket}></div>
        )
    }
    // 各片区数据获取
    const handleAreaStatisticsList = () => {
        Home.getTypeData({moduleKey: 'areaFaultAlertStatistics',dataQueryType: dataQueryType}).then(res => {
            const list = []
            const data = res.data[0] ? res.data[0].data : []
            if (data.length === 0) {
                return
            }
            data.map(item => {
                list.push({
                    areaName: item.areaName,
                    data: item.data
                })
            })
            list.map(item => {
                item.data.map(i => {
                    item[i.key] = {}
                })
            })
            list.map(item => {
                item.data.map(i => {
                    for (const key in item) {
                        if (i.key === key) {
                            if (i.typeKey === 'unfinished') {
                                item[key].alertNum = i.num
                            }
                            if (i.typeKey === 'total') {
                                item[key].count = i.num
                            }
                        }
                    }
                })
            })
            setAreaStatisticsList(list)
        })
    }
    const initAreaStatisticsDom = () => {
        return (
            <div className="statis-list area-statis-list">
            {areaStatisticsList.map((item, index) => {
                return <p key={index}>
                    <span>{item.areaName}</span>
                    <span>未完<strong style={{fontWeight: 800}}>{item['alert'].alertNum}</strong>,总<strong style={{fontWeight: 800}}>{item['alert'].count}</strong></span>
                    <span>未完<strong style={{fontWeight: 800}}>{item['fault'].alertNum}</strong>,总<strong style={{fontWeight: 800}}>{item['fault'].count}</strong></span>
                    </p>
            })}
            <p></p>
        </div>
        )
    }
    // 派单统计数据获取
    const handleDispatchStatisticsList = () => {}
    // 设备信息数据获取
    const equipmentEchartList = [
        {
            name: '燃气浓度',
            num:43,
            class: 'equipment alert'
        },
        {
            name: '位移告警',
            num:13,
            class: 'equipment fault'
        },
        {
            name: '非法开启',
            num:1687,
            class: 'equipment normal'
        }
    ]
    // 告警信息echarts设置Options
    const initAlertTypeEcharts = () => {
        const data = []
        const promise = Home.getTypeData({moduleKey: 'alertType',dataQueryType: dataQueryType}).then(res => {
            if (res.code === 0 && res.data[0]) {
                res.data[0].data.map(item => {
                    data.push({
                        name: item.alert_name,
                        value: item.num
                    })
                })
            }
            const promseObj = new Promise((resolve) => {
                resolve()
            })
            return promseObj
        })
        promise.then(() => {
            const option = {
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        name: '数量',
                        type: 'pie',
                        radius: '60%',
                        data: data,
                        center: ['50%', '40%']
                    }
                ]
            }
            const el = document.getElementById('alertEcharts')
            if(el){
                const myChart = echarts.init(el)
                myChart.setOption(option, { noMerge: false })
                myChart.resize({height: '330px' })
            }
        })
    }
    // 根据大屏数据类型初始化告警信息dom
    const initSelectSummaryInfoDom = () =>{
        return <div className="item">
                    <div className="itemTit">
                        <span className="border-green">告警类型信息</span>
                    </div>
                    <div className="itemCon equipmentEchartsBox">
                        <div id="alertEcharts"></div>
                    </div>
            </div>
    }
    // 根据大屏数据类型初始化告警信息dom
    const initSelectTypeInfoDom = () => {
        return <div className="item">
                    <div className="itemTit">
                        <span className="border-green">告警信息</span>
                    </div>
                    <div className="itemCon equipmentEchartsBox">
                        <ul className="clearfix" style={{transform: 'translateY(40%)'}}>
                            {
                                equipmentEchartList.map((item, index) => {
                                    return <li className={item.class} key={index}>
                                        <span>{item.num}</span>
                                        <p>{item.name}</p>
                                    </li>
                                })
                            }
                        </ul>
                    </div>
                </div>
    }
    // 初始化告警信息dom
    const initAlertDom = () => {
        // if (alertType === 'classification') {
            return initSelectSummaryInfoDom()
        // }
        // else {
        //     return initSelectTypeInfoDom();
        // }
    }
    // 智能设备在线数量echarts对象配置并初始化dom
    const initOnlineDom = () => {
        const data = []
        const promise = Home.getTypeData({moduleKey: 'onlineDevice',dataQueryType: dataQueryType}).then(res => {
            let count = 0
            if (res.code === 0 && res.data[0]) {
                res.data[0].data.map(item => {
                    count += Number(item.num)
                    if (item.name === '正常设备') {
                        data.push({
                            name: item.name,
                            value: item.num,
                            color: 'green'
                        })
                    } else if (item.name === '告警设备') {
                        data.push({
                            name: item.name,
                            value: item.num,
                            color: '#ff4d4f'
                        })
                    } else if (item.name === '故障设备') {
                        data.push({
                            name: item.name,
                            value: item.num,
                            color: '#ff9933'
                        })
                    }
                })
            }
            const promseObj = new Promise((resolve) => {
                setOnlineCount(count)
                resolve()
            })
            return promseObj
        })
        promise.then(res => {
            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: function (params) {
                        if (params.name === '告警设备') {
                            return '<span style=\'display:inline-block;margin-right:5px;margin-top:5px;border-radius:10px;width:9px;height:9px;background-color:#ff4d4f;\'></span>' +
                              params.name + ' : ' + params.data.value + ' 个<br/>'
                          } else if (params.name === '故障设备') {
                            return '<span style=\'display:inline-block;margin-right:5px;margin-top:5px;border-radius:10px;width:9px;height:9px;background-color:#ff9933;\'></span>' +
                              params.name + ' : ' + params.data.value + ' 个<br/>'
                          } else if (params.name === '正常设备') {
                            return '<span style=\'display:inline-block;margin-right:5px;margin-top:5px;border-radius:10px;width:9px;height:9px;background-color:green;\'></span>' +
                              params.name + ' : ' + params.data.value + ' 个<br/>'
                          }
                    }
                },
                legend: {
                    bottom: '0',
                    left: 'center',
                    textStyle: {
                        color: 'white'
                    }
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        itemStyle:{
                            color: function(params) {
                                return params.data.color
                            }
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '20',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data
                    }
                ]
            }
            const myChart = echarts.init(document.getElementById('appAratusOnlineEcharts'))
            myChart.setOption(option, { noMerge: false })
            myChart.resize({ height: '222px' })
        })
        // const data = [
        //     {
        //         name: '正常',
        //         value: 1388,
        //         color: 'green'
        //     },
        //     {
        //         name: '告警',
        //         value: 5,
        //         color: '#ff4d4f'
        //     },
        //     {
        //         name: '故障',
        //         value: 1,
        //         color: '#ff9933'
        //     }
        // ]
    }
    const handleTime = (value) => {
        equipmentRef.current.equipmentQuery = {
            ...equipmentRef.current.equipmentQuery,
            startDate: moment(value[0]).format('YYYY-MM-DD'),
            endDate: moment(value[1]).format('YYYY-MM-DD')
        }
    }
    // 根据自定义时间获取设备统计图数据
    const searchEquipmentData = () => {
        handleTicketEnableList()
    }
    // 月设备工单告警统计图数据获取并
    const handleTicketEnableList = () => {
        const params = {
            ...equipmentRef.current.equipmentQuery,
            moduleKey: 'equipmentStatistics',
            dataQueryType: dataQueryType
        }
        let data = []
        Home.getTypeData(params).then(res => {
            if (res.code === 0 && res.data[0]) {
                data = res.data[0].data
            }
            data.map(item => {
                item.day = item.createDate
                return item
            })
            initTicketEnableOption(data)
        })
    }
    // 月设备工单告警统计图初始化echarts
    const initTicketEnableOption = (data) => {
        const xAxis_data = []
        const series_data = []
        data.forEach(item => {
            xAxis_data.push(item.day)
            series_data.push(item.num)
        })
        const option = {
            grid: {
                top: '3%',
                left: '3%',
                right: '1%',
                bottom: '9%'
            },
            // dataZoom: [{
            //     type: 'slider',
            //     show: true,
            //     xAxisIndex: [0],
            //     left: '9%',
            //     bottom: -5,
            //     start: 10,
            //     end: 30 //初始化滚动条
            // }],
            xAxis: {
                type: 'category',
                data: xAxis_data,
                axisLabel: {
                    margin: 10,
                    color: '#C9C9C9',
                    textStyle: {
                        fontSize: 12
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: 'white'
                    }
                },
                axisTick: {
                    show: true
                },
                splitLine: {
                    show: false
                }
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: 'white'
                    }
                },
                axisTick: {
                    show: true
                },
                splitLine: {
                    show: false
                }
            },
            series: [{
                data: series_data,
                type: 'bar',
                barWidth: '10',
                itemStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgb(56,121,206)'
                            },
                            {
                                offset: 1,
                                color: 'rgb(80,234,248)'
                            }
                        ]),
                        barBorderRadius: [30, 30, 0, 0] //圆角大小
                    }
                },
                label: {
                    normal: {
                        show: false,
                        fontSize: 16,
                        fontWeight: 'bold',
                        color: '#333',
                        position: 'top'
                    }
                }
            }]
        }
        const myChart = echarts.init(document.getElementById('myChart1'))
        myChart.setOption(option, { noMerge: false })
        myChart.resize({ height: '300px' })
    }
    // 获取告警列表信息
    const getAlertData = () => {
        let data = []
        Home.getTypeData({moduleKey: 'pendingAlertList', dataQueryType: dataQueryType}).then(res => {
            if (res.code === 0 && res.data[0]) {
                data = res.data[0].data
            }
            data.map(item => {
                item.name = item.deviceSn
                item.time = item.createTime
                item.type = item.alertName
                item.apparatusType = item.deviceTypeName
                return item
            })
            setPendingAlertList(data)
        })
    }
    // 初始化告警列表信息和dom
    const initAlertListDom = () => {
        // const alertList = [
        //     {
        //         name: '合CDFY00901',
        //         time: '01-02 11:39:05',
        //         type: '非法开启',
        //         apparatusType: '通讯类'
        //     }
        // ]
        return <div className="StateBox">
                    <div className="StateTit clearfix">
                        <span>设备编号</span>
                        <span>上报时间</span>
                        <span>设备类型</span>
                        <span>告警类型</span>
                    </div>
                    <div className="StateCont">
                        <ul>
                        <Carousel autoplay={pendingAlertList.length > 4} dots={false} dotPosition="left">
                            {
                                pendingAlertList.map((item, index) => {
                                    return <li key={index}>
                                        <div className="fontInner clearfix">
                                            <span title={item.name} style={{fontSize: '12px'}}>{item.name}</span>
                                            <span>{item.time}</span>
                                            <span>{item.apparatusType}</span>
                                            <span>{item.type}</span>
                                        </div>
                                    </li>
                                })
                            }
                        </Carousel>
                        </ul>
                    </div>
                </div>
    }
    // 获取故障列表信息
    const getFaultData = () => {
        let data = []
        Home.getTypeData({moduleKey: 'pendingFaulttList',dataQueryType: dataQueryType}).then(res => {
            if (res.code === 0 && res.data[0]) {
                data = res.data[0].data
            }
            data.map(item => {
                item.name = item.installationSn
                item.time = item.createTime
                item.type = item.faultTypeName
                item.apparatusType = item.deviceTypeName
                return item
            })
            setPendingFaulttList(data)
        })
    }
    // 初始化故障列表信息和dom
    const initFlautListDom = () => {
        const FaultList = [
            {
                name: 'CDFY00901',
                time: '01-02 11:39:05',
                type: '非法开启',
                apparatusType: '通讯类'
            }
        ]
        return <div className="StateBox">
                    <div className="StateTit clearfix">
                        <span>设施编号</span>
                        <span>上报时间</span>
                        <span>设施类型</span>
                        <span>故障类型</span>
                    </div>
                    <div className="StateCont">
                        <ul>
                        <Carousel autoplay={pendingFaulttList.length > 4} dots={false} dotPosition="left">
                            {
                                pendingFaulttList.map((item, index) => {
                                    return <li key={index}>
                                        <div className="fontInner clearfix">
                                            <span style={{fontSize: '12px'}}>{item.name}</span>
                                            <span>{item.time}</span>
                                            <span>{item.apparatusType}</span>
                                            <span>{item.type}</span>
                                        </div>
                                    </li>
                                })
                            }
                        </Carousel>
                        </ul>
                    </div>
                </div>
    }
    // 告警列表or故障类型列表type切换
    const selectTypeList = (params) => {
        setSelectAlertOrFault(params)
    }
    // 初始化告警列表or故障类型列表Dom
    const initAlertOrFaultDom = () => {
        return selectAlertOrFault === '0' ? initAlertListDom() : initFlautListDom()
    }
    const getNoCompletedTicketList = () => {
        Home.getTypeData({moduleKey: 'pendingTicket', dataQueryType: dataQueryType}).then(res => {
            let data = []
            if (res.code === 0 && res.data[0]) {
                data = res.data[0].data
            }
            data.map(item => {
                item.time = item.createTime
                item.type = item.ticketType
                item.area = item.areaName
                item.acceptor = item.tickStatus
                return item
            })
            setNoCompletedTicketList(data)
        })
    }
    // 初始化待完成工单处理统计信息NoCompletedTicket
    const initNoCompletedTicketDom = () => {
        // const FaultList = [
        //     {
        //         time: '2020-1-1 11:39:05',
        //         type: '告警工单',
        //         acceptor: '非法开启',
        //         area: '临海新城'
        //     }
        // ]
        return <div className="StateBox">
                    <div className="StateTit clearfix">
                        <span>时间</span>
                        <span>类型</span>
                        <span>工单状态</span>
                        <span>片区</span>
                    </div>
                    <div className="StateCont" style={{height: '200px'}}>
                        <ul>
                        <Carousel autoplay={noCompletedTicketList.length > 4} dots={false} dotPosition="left">
                            {
                                noCompletedTicketList.map((item, index) => {
                                    return <li key={index}>
                                        <div className="fontInner clearfix">
                                            <span>{item.time}</span>
                                            <span>{item.type}</span>
                                            <span>{item.acceptor}</span>
                                            <span>{item.area}</span>
                                        </div>
                                    </li>
                                })
                            }
                        </Carousel>
                        </ul>
                    </div>
                </div>
    }
    // 月设备工单告警统计图类型切换
    const setSelectStatisticsType = (params) => {
        setselectStatisticsType(params)
    }
    // 月设备工单告警选项Dom生成
    const selectStatisticsTypeDom = () => {
        return  <a style={{color: 'white'}}>{selectStatisticsType}</a>
    }
    // 月设备工单告警统计图时间切换
    const setSelectStatisticsTime = (params) => {
        let value = 1
        switch (params) {
            case '近一月':
                value = 2
                break;
            case '近一周':
                value = 1
                break;
            case '自定义':
                    value = 3
                break;
            default:
                break;
        }
        equipmentRef.current.equipmentQuery = {
            ...equipmentRef.current.equipmentQuery,
            dateType: value,
            startDate: undefined,
            endDate: undefined
        }
        handleTicketEnableList()
        setselectStatisticsTime(params)
    }
    // 月设备工单告警时间选项Dom生成
    const selectStatisticsTimeDom = () => {
        return  <a>{selectStatisticsTime}</a>
    }
    // 设置最大选择日期
    const disabledDate = (current) => {
        return current && current > moment().endOf('day') || current < moment().subtract(1, 'months')
    }
    const initCustomTimeDom = () => {
        return <div style={{float: 'left',height: '20px'}}>
                <RangePicker
                    locale={locale}
                    style={{height: '20px'}}
                    className="custom_date"
                    placeholder={['开始日期', '结束日期']}
                    // allowClear={false}
                    disabledDate={disabledDate}
                    format={'YYYY-MM-DD'}
                    onChange={handleTime}
                />
            </div>
    }
    const initSearchBtn = () => {
        return <div style={{float: 'left',height: '20px',color:'white',marginTop:'1px'}}>
                <a style={{background: 'rgb(2, 182, 212)',color:'white',padding:'2px'}} onClick={searchEquipmentData}>查询</a>
            </div>
    }
    // 打开工作量统计modal
    const openStatisticsModal = () => {
        props.subClick(true, 'filterbg')
    }
    const selectGzltjTime = (params) => {
        const dom = document.getElementById('ticket')
        const option = {
            title: {
                text: ''
            },
            legend: {
                data: []
            },
            grid: {
                width: '70%',
                left: '20%',
                top: '0',
                right: '0',
                bottom: '0'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'none'
                },
                formatter: function (params) {
                  if (params[0].name === '巡检工单') {
                    return '<span style=\'display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#ff4d4f;\'></span>' +
                      params[0].name + ' : ' + Number((params[0].value.toFixed(0) * 1).toFixed(2)).toLocaleString() + ' 个<br/>'
                  } else if (params[0].name === '故障工单') {
                    return '<span style=\'display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:#ff9933;\'></span>' +
                      params[0].name + ' : ' + Number((params[0].value.toFixed(0) * 1).toFixed(2)).toLocaleString() + ' 个<br/>'
                  } else if (params[0].name === '告警工单') {
                    return '<span style=\'display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:green;\'></span>' +
                      params[0].name + ' : ' + Number((params[0].value.toFixed(0) * 1).toFixed(2)).toLocaleString() + ' 个<br/>'
                  }
                }
            },
            xAxis: {
                show: false,
                type: 'value'
            },
            yAxis: [
                {
                    type: 'category',
                    inverse: true,
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: 'white',
                            fontSize: '16px'
                        }
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    }
                },
                {
                    type: 'category',
                    inverse: true,
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: 'white',
                            fontSize: '20px'
                        },
                        formatter: (value) => {
                            return value
                        }
                    },
                    data: [],
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    }
                }
            ],
            series: [
                {
                    type: 'bar',
                    zlevel: 1,
                    itemStyle: {
                        normal: {
                            barBorderRadius: 30,
                            color: function (params) {
                                if (params.name === '巡检工单') {
                                 return '#ff4d4f'
                                } else if (params.name === '故障工单') {
                                 return '#ff9933'
                                } else if (params.name === '告警工单') {
                                 return 'green'
                                }
                            }
                        }
                    },
                    label: {
                        normal: {
                            show: true,
                            position: ['300%', '-250%'],
                            // position: 'insideBottomRight',
                            color: '#fff',
                            fontSize: 15,
                            formatter: function(param) {
                                let label = 0
                                if (ticket.current.ticketDataList.length > 0) {
                                    ticket.current.ticketDataList.some(item => {
                                        if (item.name === param.name) {
                                            label = param.data <= 0 ? 0 : (Math.round(param.data / item.count * 10000) / 100.00)
                                            return true
                                        }
                                    })
                                }
                                return label + '%'
                            }
                        }
                    },
                    barWidth: 5,
                    data: []
                },
                {
                    name: '背景',
                    type: 'bar',
                    barWidth: 5,
                    barGap: '-100%',
                    data: [100, 100, 100],
                    itemStyle: {
                        normal: {
                            color: '#ccc',
                            barBorderRadius: 30
                        }
                    }
                }
            ]
        }
        ticket.current.echartObj.setOption(option, true)
        setGzltjTime(params)
        getTicketDataList(params === '近一月' ? 2 : 1)
    }
    // 底部轮播样式设置
    const contentStyle = {
        height: '30px'
    };
    const timedTask = () => {
        getTicketDataList()
        handleAreaStatisticsList()
        initAlertTypeEcharts()
        initOnlineDom()
        handleTicketEnableList()
        getAlertData()
        getFaultData()
        getNoCompletedTicketList()
    }
    // useEffect(() => {
    //     initOnlineDom()
    //     handleAreaStatisticsList()
    //     getTicketDataList()
    //     getNoCompletedTicketList()
    //     getAlertData()
    //     getFaultData()
    //     return () => {
    //     }
    // }, [])
    useEffect(() => {
        initAlertDom()
        setAlertType(props.isShowAlertType)
        switch (props.isShowAlertType) {
            case 'classification':
                setDataQueryType(1)
                break;
            case 'communication':
                setDataQueryType(2)
                break;
            case 'waterAffairs':
                setDataQueryType(3)
                break;
            default:
                break;
        }
        if (props.isShowAlertType === 'classification') {
            setInitDomStatus(Math.random())
        } else {
            setInitDomStatus(undefined)
        }
    }, [props.isShowAlertType])
    useEffect(() => {
        if (initDomStatus !== undefined) {
            initAlertTypeEcharts()
        }
    }, [initDomStatus])
    useEffect(() => {
        initAlertOrFaultDom()
    }, [selectAlertOrFault])
    useEffect(() => {
        selectStatisticsTypeDom()
    }, [selectStatisticsType])
    useEffect(() => {
        selectStatisticsTimeDom()
    }, [selectStatisticsTime])
    useEffect(() => {
        const status = 0
            getTicketDataList()
            handleAreaStatisticsList()
            initAlertTypeEcharts()
            initOnlineDom()
            handleTicketEnableList()
            getAlertData()
            getFaultData()
            getNoCompletedTicketList()
    }, [dataQueryType])
    useEffect(() => {
       const timer =  window.setInterval(timedTask , 1000 * 60)
       return () => clearInterval(timer);
    },[])
    useEffect(() => {
        let value = 1
        // 1 工单量; 2 燃气告警; 3 正常施工; 4 告警量; 5 故障量
        switch (selectStatisticsType) {
            case '工单量':
                value = 1
                break;
            case '燃气告警':
                value = 2
                break;
            case '正常施工':
                value = 3
                break;
            case '告警量':
                value = 4
                break;
            case '故障量':
                value = 5
                break;
            default:
                break;
        }
        equipmentRef.current.equipmentQuery = {
            ...equipmentRef.current.equipmentQuery,
            queryType: value
        }
        handleTicketEnableList()
    }, [selectStatisticsType])
    useEffect(() => {
        if(areaStatisticsList.length > 0) {
            initAreaStatisticsDom()
        }
    }, [areaStatisticsList])
    useEffect(() => {
        if (ticketList.length > 0) {
            initTicketEchartOption()
        }
    }, [ticketList])
    return (
        <div id="main">
            <div className="wp">
                <Row className="row_box" gutter={24}>
                    <div className="left public-plate">
                        <div className="item">
                            {initAlertDom()}
                            {/* <div className="itemTit">
                                <span className="border-yellow">工作量统计</span>
                            </div>
                            <div className="itemCon">
                                {initTicketEchartDom()}
                            </div> */}
                        </div>
                        <div className="item">
                            <div className="itemTit">
                                <span className="border-green">各片区故障告警统计</span>
                            </div>
                            <div className="itemCon no-itemCon-bg">
                                <Row  gutter={24} style={{color:'white',fontSize: '18px',textAlign:'center'}}>
                                    <Col span={8}></Col>
                                    <Col span={8}>告警</Col>
                                    <Col span={8}>故障</Col>
                                </Row>
                                {
                                    initAreaStatisticsDom()
                                }
                            </div>
                        </div>
                        <div className="item">
                            <div className="itemTit">
                                <span className="border-blue">待完成工单处理统计信息</span>
                            </div>
                            <div className="itemCon no-itemCon-bg" style={{padding: '0 12px'}}>
                                {initNoCompletedTicketDom()}
                            </div>
                        </div>
                    </div>
                    <div className="center public-plate">
                        <div className="centerWp">
                            <div className="mapContainer">
                                <Map />
                            </div>
                            <div className="billChart">
                                <div className="itemTit .clearfix">
                                    <span className="border-blue" style={{float: 'left'}}>
                                        设备统计图
                                    </span>
                                    <div className="tj_time_style"  style={{float: 'left'}}>
                                        {selectStatisticsTimeDom()}
                                        <div className="dropdown">
                                            <a onClick={() => setSelectStatisticsTime('近一周')}>近一周</a>
                                            <a onClick={() => setSelectStatisticsTime('近一月')}>近一月</a>
                                            <a onClick={() => setSelectStatisticsTime('自定义')}>自定义</a>
                                        </div>
                                    </div>
                                    {selectStatisticsTime === '自定义' ? initCustomTimeDom() : null}
                                    {selectStatisticsTime === '自定义' ? initSearchBtn() : null}
                                    <div className="tj_type_style" style={{float: 'left', color: 'white'}}>
                                        {selectStatisticsTypeDom()}
                                        <div className="dropdown">
                                            <a onClick={() => setSelectStatisticsType('工单量')}>工单量</a>
                                            <a onClick={() => setSelectStatisticsType('燃气告警')}>燃气告警</a>
                                            <a onClick={() => setSelectStatisticsType('正常施工')}>正常施工</a>
                                            <a onClick={() => setSelectStatisticsType('告警量')}>告警量</a>
                                            <a onClick={() => setSelectStatisticsType('故障量')}>故障量</a>
                                        </div>
                                    </div>
                                </div>
                                <div id="myChart1" style={{marginTop:'30px'}}></div>
                            </div>
                        </div>
                        {/* <div className="itemCon">
                            <div className="billState rolls">
                                <div className="StateBox">
                                    <Carousel dots={false} autoplay dotPosition="left">
                                        <p>2021-01-01 10:15:12 张先生 受理了 临海新城 设施 【编号：RQ19872312, 专业：水务, 地址：人南立交桥 东】的巡检工单</p>
                                        <p>2021-01-01 10:15:12 张先生 受理了 临海新城 设施 【编号：RQ19872312, 专业：水务, 地址：人南立交桥 东】的巡检工单</p>
                                        <p>2021-01-01 10:15:12 张先生 受理了 临海新城 设施 【编号：RQ19872312, 专业：水务, 地址：人南立交桥 东】的巡检工单</p>
                                        <p>2021-01-01 10:15:12 张先生 受理了 临海新城 设施 【编号：RQ19872312, 专业：水务, 地址：人南立交桥 东】的巡检工单</p>
                                        <p>2021-01-01 10:15:12 张先生 受理了 临海新城 设施 【编号：RQ19872312, 专业：水务, 地址：人南立交桥 东】的巡检工单</p>
                                        <p>2021-01-01 10:15:12 张先生 受理了 临海新城 设施 【编号：RQ19872312, 专业：水务, 地址：人南立交桥 东】的巡检工单</p>
                                        <p>2021-01-01 10:15:12 张先生 受理了 临海新城 设施 【编号：RQ19872312, 专业：水务, 地址：人南立交桥 东】的巡检工单</p>
                                        <p>2021-01-01 10:15:12 张先生 受理了 临海新城 设施 【编号：RQ19872312, 专业：水务, 地址：人南立交桥 东】的巡检工单</p>
                                    </Carousel>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className="right public-plate">
                        <div className="item total itembg">
                            <div className="itemTit">
                                <span className="border-yellow">智能设备在线数量</span>
                            </div>
                            <div className="itemCon clearfix">
                                <div className="totalNum" style={{width:'70%'}}>
                                    <div id="appAratusOnlineEcharts"></div>
                                </div>
                                <div className="totalNum" style={{width:'30%', float: 'right',marginTop: '65px'}}>
                                    <strong id="totalNum" total={onlineCount}>{onlineCount}</strong>
                                    <span>个设备</span>
                                </div>
                            </div>
                            {/* {initAlertDom()} */}
                        </div>
                        <div className="item">
                            {/* {initAlertDom()} */}
                            <div className="itemTit">
                                <span className="border-yellow">工作量统计</span>
                                <div className="gzltj_time">
                                    <a style={{color:'white'}}>{gzltjTime}</a>
                                    <div className="gzltj_time_box">
                                        <p onClick={() => selectGzltjTime('近一周')}><a>近一周</a></p>
                                        <p onClick={() => selectGzltjTime('近一月')}><a>近一月</a></p>
                                    </div>
                                </div>
                                <span style={{marginLeft:'20px'}} className="border-yellow" onClick={openStatisticsModal}><a style={{color: 'white'}}>详情</a></span>
                            </div>
                            <div className="itemCon">
                                {initTicketEchartDom()}
                            </div>
                        </div>
                        <div className="item" style={{marginBottom: 0}}>
                            <div className="itemTit alertOrFault-style">
                                <div onClick={() => selectTypeList('0')}><span className="border-green">未受理告警列表</span></div>
                                <div onClick={() => selectTypeList('1')}><span className="border-red">未受理故障列表</span></div>
                            </div>
                            <div className="itemCon" style={{padding: '0 12px'}}>
                                {initAlertOrFaultDom()}
                            </div>
                        </div>
                    </div>
                </Row>
            </div>
        </div>
    )
}
export default Main